import { HouseSolidV6 } from "@shared/v2/Icomoon";
import HomeInfoOverlay from "./HomeInfoOverlay";

const intentMap = {
  buyer: "Buying",
  seller: "Selling",
  buyer_seller: "Both",
  "seller/buyer": "Both",
};

const OpenHouseEvent = ({ event, event: { timeline_fields: timelineFields } }) => (
  <div className="timeline-event tw-px-[20px] tw-flex tw-gap-[16px]">
    <div className="tw-flex-1 tw-flex tw-gap-[16px]">
      <div className="tw-flex tw-justify-center tw-items-center tw-w-[40px] tw-h-[40px] tw-flex-none tw-rounded-full tw-border-solid tw-border-[2px]">
        <HouseSolidV6 size="l" />
      </div>
      <div className="tw-break-all tw-flex tw-flex-col tw-gap-[4px]">
        <div>
          <span className="tw-font-semibold">{timelineFields.contact || "No Name"}</span> attended an open
          house
        </div>
        <HomeInfoOverlay timelineFields={timelineFields} />
        <div>
          Address: {timelineFields.street_address} {timelineFields.city}, {timelineFields.state}{" "}
          {timelineFields.postal_code}
        </div>
        <div>Host: {timelineFields.host}</div>
        {timelineFields.intent && <div>Buying or Selling: {intentMap[timelineFields.intent]}</div>}
        {timelineFields.timline && <div>{timelineFields.timeline}</div>}
        {timelineFields.home_value_address && (
          <div>Home Value Address: {timelineFields.home_value_address}</div>
        )}
        {(timelineFields.working_with_an_agent || timelineFields.working_with_agent) && (
          <div>
            Working with an agent: {timelineFields.working_with_an_agent || timelineFields.working_with_agent}
          </div>
        )}
        {timelineFields.selling_timeframe && <div>Selling Timeframe: {timelineFields.selling_timeframe}</div>}
        {timelineFields.phone && <div>Phone: {timelineFields.phone}</div>}
        {timelineFields.email && <div>Email: {timelineFields.email}</div>}
      </div>
    </div>
    <span className="time-ago">{event.interacted_at_absolute}</span>
  </div>
);

export default OpenHouseEvent;
